<template>
  <div class="appContainer top_container list-company">
    <div class="title" v-if="checkLengthFavoriteCompany() === true">
      <div class="line"></div>
      <h1>
        {{ $t('list-company-page.favorite-company', { split: '/' }) }}
      </h1>
    </div>
    <div class="optionCompany" v-if="checkLengthFavoriteCompany() === true">
      {{ $t('list-company-page.option-text') }}
      <div class="form-select">
        <select
          name="company_list_option"
          v-model="favorite_company_list_option"
        >
          <option value="1">
            {{ $t('list-company-page.option-list') }}
          </option>
          <option value="2">
            {{ $t('list-company-page.option-grid') }}
          </option>
        </select>
      </div>
    </div>
    <br />
    <div v-if="favorite_company_list_option == 2">
      <div class="list_company" v-if="checkLengthFavoriteCompany() === true">
        <CompanyCardFavorite
          v-for="item in companyData.favoriteCompany"
          :key="item && item.id"
          :item="item"
          pclass="company_card"
        />
      </div>
    </div>
    <div class="company-table" v-else-if="favorite_company_list_option == 1">
      <v-data-table
        :headers="headers"
        :items="
          companyData.favoriteCompany !== null &&
          typeof companyData.favoriteCompany !== 'undefined' &&
          companyData.favoriteCompany.length !== 0
            ? companyData.favoriteCompany
            : []
        "
        :items-per-page="10"
        class="elevation-1 app_table"
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.information.industry_type`]="{ item }">
          {{
            item !== null && typeof item !== 'undefined'
              ? industryTypeFormat(item.information.industry_type)
              : ''
          }}
        </template>
        <template v-slot:[`item.company_name`]="{ item }">
          <router-link
            v-if="checkListCompanyDisplay"
            :to="'list-company' + '/' + item.id + '/detail'"
          >
            <span>
              {{
                item.information !== null &&
                item.information.complete_flag === 1
                  ? item.information.company_name
                  : item.company_name
              }}
            </span>
          </router-link>
          <span v-else>
            {{
              item.information !== null && item.information.complete_flag === 1
                ? item.information.company_name
                : item.company_name
            }}
          </span>
        </template>
      </v-data-table>
    </div>
    <!-- <div class="hr-line"></div> -->
    <hr class="hr-line" v-if="checkLengthFavoriteCompany() === true" />

    <div class="title mt-4">
      <div class="line"></div>
      <h1>{{ $t('list-company-page.list-company', { split: '/' }) }}</h1>
    </div>
    <div class="optionCompany">
      {{ $t('list-company-page.option-text') }}
      <div class="form-select">
        <select name="company_list_option" v-model="company_list_option">
          <option value="1">
            {{ $t('list-company-page.option-list') }}
          </option>
          <option value="2">
            {{ $t('list-company-page.option-grid') }}
          </option>
        </select>
      </div>
    </div>

    <br />

    <div v-if="company_list_option == 2">
      <div class="list_company">
        <CompanyCard
          v-for="item in companyData.listCompany"
          :key="item && item.id"
          :item="item"
          pclass="company_card"
        />
      </div>
    </div>

    <div class="company-table" v-else-if="company_list_option == 1">
      <v-data-table
        :headers="headers"
        :items="
          companyData.listCompany !== null &&
          typeof companyData.listCompany !== 'undefined' &&
          companyData.listCompany.length !== 0
            ? companyData.listCompany
            : []
        "
        :items-per-page="10"
        class="elevation-1 app_table"
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.information.industry_type`]="{ item }">
          {{
            item !== null && typeof item !== 'undefined'
              ? industryTypeFormat(item.information.industry_type)
              : ''
          }}
        </template>
        <template v-slot:[`item.company_name`]="{ item }">
          <router-link
            :to="'list-company' + '/' + item.id + '/detail'"
            v-if="typeof item !== 'undefined' && checkListCompanyDisplay"
          >
            <span>
              {{
                typeof item !== 'undefined' &&
                item !== null &&
                item.information !== null &&
                typeof item.information !== 'undefined' &&
                item.information.complete_flag === 1
                  ? item.information.company_name
                  : typeof item !== 'undefined'
                  ? item.company_name
                  : ''
              }}
            </span>
          </router-link>
          <span v-else>
            {{
              typeof item !== 'undefined' &&
              item !== null &&
              item.information !== null &&
              typeof item.information !== 'undefined' &&
              item.information.complete_flag === 1
                ? item.information.company_name
                : typeof item !== 'undefined'
                ? item.company_name
                : ''
            }}
          </span>
        </template>
      </v-data-table>
    </div>

    <!-- <TableListCompany
      :dataTable="companyData.listCompany"
      :showType="listCompanyShowType"
    /> -->

    <ScrollTopBtn />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CompanyCard from '@/components/CompanyCard';
import CompanyCardFavorite from '@/components/CompanyCardFavorite';
import ScrollTopBtn from '@/components/ScrollTopBtn';
// import TableListCompany from './TableListCompany';

import './listCompany.scss';

import { TYPE_GRID, TYPE_TABLE } from '@/common/constants';
import moment from 'moment-timezone';

export default {
  name: 'listCompany',
  components: {
    CompanyCard,
    CompanyCardFavorite,
    ScrollTopBtn
    // TableListCompany
  },

  data: function () {
    return {
      company_list_option: 2,
      favorite_company_list_option: 2,
      listCompanyShowType: TYPE_TABLE,

      optionTypes: [
        {
          name: 'top-page.show-type.type-grid',
          value: TYPE_GRID
        },
        {
          name: 'top-page.show-type.type-table',
          value: TYPE_TABLE
        }
      ],
      headers: [
        {
          text: this.$t('list-company-page.company-name'),
          sortable: false,
          align: 'start',
          value: 'company_name'
        },

        {
          text: this.$t('list-company-page.business-content'),
          align: 'start',
          sortable: false,
          value: 'information.business_content'
        },

        {
          text: this.$t('list-company-page.industry-type'),
          align: 'start',
          sortable: false,
          value: 'information.industry_type'
        },
        {
          text: this.$t('list-company-page.office-location'),
          align: 'start',
          sortable: false,
          value: 'information.office_location'
        }
      ]
    };
  },

  created() {
    this.TYPE_GRID = TYPE_GRID;
    this.TYPE_TABLE = TYPE_TABLE;

    this.$store.dispatch('getCompanies');
  },

  methods: {
    checkLengthFavoriteCompany() {
      const { favoriteCompany } = this.companyData;

      if (typeof favoriteCompany !== 'undefined' && favoriteCompany !== null) {
        if (favoriteCompany.length > 0) {
          return true;
        }
      }
      return false;
    },
    industryTypeFormat: function (id) {
      const arr = this.mIndustryType.filter((ele) => ele.id === id);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },
    getDateFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD');
      }
    },
    getDateTimeFromUTC() {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        return moment(new Date())
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');
      }
    },
    checkDisplayListCompany(fromData, toData) {
      const timeZoneFilter = this.c_time_zone.filter(
        (timezone) => timezone.id == this.m_event.time_zone
      );

      if (timeZoneFilter.length > 0) {
        const dateFrom = moment
          .utc(fromData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const dateTo = moment
          .utc(toData)
          .tz(timeZoneFilter[0].time_zone_code)
          .format('YYYY-MM-DD HH:mm:ss');

        const now = this.getDateTimeFromUTC();

        if (now < dateFrom || now > dateTo) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  },

  watch: {
    companyData: function (val) {
      return val;
    },
    getMIndustryType: function (val) {
      return val;
    }
  },
  computed: {
    ...mapGetters({
      companyData: 'getCompanyData',
      mIndustryType: 'getMIndustryType'
    }),
    checkListCompanyDisplay: function () {
      if (this.m_event !== null) {
        const {
          company_publicizing_period_from,
          company_publicizing_period_to
        } = this.m_event;
        if (
          company_publicizing_period_from !== null &&
          company_publicizing_period_to !== null
        ) {
          return this.checkDisplayListCompany(
            company_publicizing_period_from,
            company_publicizing_period_to
          );
        }
      }
      return false;
    }
  }
};
</script>

<style lang="scss">
@import './listCompany.scss';
.hr-line {
  margin-top: 30px;
  margin-bottom: 28px;
  width: 100%;
  border-top: 1px dashed #00a2ff;
}
</style>
